import { memo } from 'react';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { useSelector } from '@client/hooks/redux.hooks';
import { hasDisabledNavigationSelector, hasNoWindowChromeSelector } from '@client/selectors/helpers/router';
import { hasFooterSelector } from '../../Footer/selectors';

export const MobileSpacer = memo(() => {
  const isMobile = useIsMobile();
  const hasFooter = useSelector(hasFooterSelector);
  const hasNoWindowChrome = !!(useSelector(hasNoWindowChromeSelector));
  const hasDisabledNavigation = !!(useSelector(hasDisabledNavigationSelector));

  // We add a 54 pixel spacer to the bottom of the page to account for the BottomAppBar component
  // The footer includes 54 pixels of padding on its own, so we can ignore pages that have a footer
  // We also ignore pages that have no bottom app bar at all
  if (!isMobile || hasFooter || hasNoWindowChrome || hasDisabledNavigation) {
    return null;
  }

  return <div style={{ height: 54 }} />;
});
